var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 201,
    viewBox: "0 0 200 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3548_23430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.017 157.102C143.441 157.102 177.023 123.521 177.023 82.0958C177.023 40.6712 143.441 7.08984 102.017 7.08984C60.5921 7.08984 27.0107 40.6712 27.0107 82.0958C27.0107 123.521 60.5921 157.102 102.017 157.102Z",
    fill: "url(#paint0_linear_3548_23430)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.017 7.08984C61.1153 7.08984 27.884 39.834 27.0508 80.5364C34.942 115.29 66.4958 145.574 102.017 145.574C138.477 145.574 170.241 114.094 176.927 78.2928C174.946 38.6357 142.166 7.08984 102.017 7.08984Z",
    fill: "url(#paint1_linear_3548_23430)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175.584 67.4587C168.775 33.0431 138.431 7.08984 102.017 7.08984C65.5236 7.08984 35.1311 33.1571 28.4092 67.6838C30.8279 79.6602 37.4117 98.4114 55.3017 107.415C82.7574 121.232 151.485 105.62 161.893 94.8534C169.177 87.3183 173.82 75.8311 175.584 67.4587Z",
    fill: "url(#paint2_linear_3548_23430)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.892 52.3785C159.382 25.7391 132.881 7.08984 102.017 7.08984C70.1937 7.08984 43.0201 26.9174 32.123 54.8842C32.9673 64.0278 37.1144 80.9025 55.8407 90.9063C82.04 104.903 117.032 102.391 118.467 101.673C119.903 100.955 164.585 75.436 164.585 75.436C164.585 75.436 171.909 65.9843 170.892 52.3785Z",
    fill: "url(#paint3_linear_3548_23430)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165.013 75.5942C165.013 42.783 136.812 16.1836 102.024 16.1836C67.2351 16.1836 39.0342 42.782 39.0342 75.5942C39.0342 92.0638 46.1422 106.965 57.6194 117.726C67.047 108.3 102.024 72.4233 102.024 72.4233L146.028 118.086C157.735 107.298 165.013 92.2509 165.013 75.5942Z",
    fill: "url(#paint4_radial_3548_23430)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164.691 69.567C157.027 61.9009 148.434 52.3242 148.434 52.3242L132.642 57.8868C132.642 57.8868 111.109 67.5765 105.886 72.4218C104.96 73.2801 104.373 73.9503 104.026 74.5004L146.028 118.085C157.736 107.297 165.013 92.2504 165.013 75.5927C165.013 73.5592 164.903 71.5486 164.691 69.567Z",
    fill: "url(#paint5_linear_3548_23430)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6611 76.3309L79.0287 98.8562L97.7789 80.9722L95.9114 68.7908C95.9114 68.7908 93.7748 66.5452 92.0643 67.1334C90.3549 67.7235 55.6611 76.3309 55.6611 76.3309Z",
    fill: "url(#paint6_linear_3548_23430)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.762 27.0088L120.362 31.38H129.25C129.824 31.38 130.399 31.5081 130.892 31.8032C132.133 32.5444 133.822 34.2628 133.466 37.1527C132.974 41.1548 131.013 42.7712 131.013 42.7712L134.584 44.9258C134.584 44.9258 138.463 40.5546 137.909 34.951C137.533 31.145 134.059 28.8443 131.869 27.76C130.87 27.2659 129.778 27.0078 128.663 27.0078H118.762V27.0088Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9594 27.0088L83.3589 31.38H74.4714C73.8973 31.38 73.3221 31.5081 72.829 31.8032C71.5876 32.5444 69.8991 34.2628 70.2552 37.1527C70.7474 41.1548 72.7079 42.7712 72.7079 42.7712L69.1369 44.9258C69.1369 44.9258 65.2578 40.5546 65.812 34.951C66.1881 31.145 69.6621 28.8443 71.8517 27.76C72.851 27.2659 73.9433 27.0078 75.0576 27.0078H84.9594V27.0088Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6191 117.728C69.0073 128.406 84.6967 135.007 102.024 135.007C119.151 135.007 134.673 128.55 146.028 118.089L102.024 72.4258C102.023 72.4248 67.0468 108.303 57.6191 117.728Z",
    fill: "url(#paint7_linear_3548_23430)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.434 52.3251H113.918V38.7773H89.3586V52.3261H55.6611V76.3319H89.2085V133.205C89.2085 140.256 94.9251 145.972 101.976 145.972C109.027 145.972 114.744 140.256 114.744 133.205V76.3309H148.434V52.3251Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.561 18.375C93.7632 18.375 87.4414 24.5127 87.4414 32.0838C87.4414 39.655 93.7632 45.7927 101.561 45.7927C109.36 45.7927 115.681 39.655 115.681 32.0838C115.681 24.5127 109.36 18.375 101.561 18.375ZM101.748 38.8717C98.1754 38.8717 95.2786 35.9749 95.2786 32.4019C95.2786 28.8289 98.1754 25.9321 101.748 25.9321C105.321 25.9321 108.218 28.8289 108.218 32.4019C108.218 35.9749 105.321 38.8717 101.748 38.8717Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4143 54.6641H88.3863H88.2012H87.0049C87.0269 54.7211 87.9341 58.037 90.3328 60.6487C92.7225 63.2585 96.6556 65.8912 102.523 65.8852C104.923 65.8862 107.004 65.205 108.745 64.1957C111.358 62.6793 113.219 60.4457 114.442 58.5972C115.663 56.7476 116.296 54.6971 116.31 54.6641H114.89H114.882C114.78 54.9181 113.732 57.4528 111.68 59.8175C110.655 61.0008 109.381 62.1552 107.862 63.0064C106.34 63.8576 104.579 64.4128 102.524 64.4138C97.1087 64.4078 93.6237 62.0411 91.4161 59.6525C90.3178 58.4581 89.5526 57.2578 89.0655 56.3625C88.8224 55.9144 88.6483 54.9201 88.5363 54.6641H88.4143Z",
    fill: "#69E4E4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6124 54.6641H87.5994H87.5974H87.0043H83.2002C83.2252 54.8441 83.5453 59.1623 86.04 63.4995C87.2903 65.6621 89.1179 67.8858 91.7526 69.5612C93.8562 70.9046 96.4719 71.8559 99.5808 72.184V132.595C99.5808 133.813 100.568 134.801 101.787 134.801C103.006 134.801 103.994 133.814 103.994 132.595V72.216C107.093 71.9189 109.713 70.9356 111.81 69.5422C113.715 68.2839 115.198 66.7224 116.344 65.118C118.065 62.7083 119.047 60.2026 119.622 58.2851C120.195 56.3665 120.355 54.7581 120.367 54.6641H115.984C115.979 54.7671 115.483 58.112 113.48 61.446C112.475 63.1274 111.118 64.7349 109.292 65.9182C107.461 67.0975 105.153 67.9018 102.003 67.9078H102C98.5355 67.9018 96.0438 67.0545 94.1232 65.8402C92.6848 64.9249 91.5625 63.7796 90.6723 62.5453C89.3379 60.6977 88.5487 58.6452 88.1136 57.0667C87.8955 56.2785 87.7645 55.1232 87.6895 54.6651H87.6124V54.6641Z",
    fill: "#122045"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96777 172.953H11.5665V175.776H8.32055V192.716H5.21468V175.776H1.96777V172.953Z",
    fill: "#38879F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1393 192.716C20.9703 192.208 20.8572 191.897 20.8572 190.287V187.182C20.8572 185.348 20.2361 184.669 18.8247 184.669H17.7514V192.716H14.6465V172.953H19.3328C22.5507 172.953 23.9341 174.45 23.9341 177.498V179.052C23.9341 181.083 23.2849 182.383 21.9015 183.032V183.088C23.454 183.737 23.9621 185.206 23.9621 187.267V190.316C23.9621 191.275 23.9901 191.981 24.3012 192.716H21.1393ZM17.7504 175.776V181.847H18.9647C20.122 181.847 20.8282 181.338 20.8282 179.757V177.808C20.8282 176.397 20.3481 175.776 19.2478 175.776H17.7504Z",
    fill: "#38879F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7685 192.716H34.6346L34.0984 189.13H30.2874L29.7502 192.716H26.8994L30.0613 172.953H34.6066L37.7685 192.716ZM30.6815 186.448H33.6743L32.2069 176.454H32.1509L30.6815 186.448Z",
    fill: "#38879F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7561 178.402H43.7001V192.716H40.9053V172.953H44.8014L47.9352 184.782H47.9913V172.953H50.758V192.716H47.5671L43.7561 178.402Z",
    fill: "#38879F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8888 172.727C61.9096 172.727 63.462 174.533 63.462 177.695V178.316H60.5262V177.498C60.5262 176.086 59.9621 175.55 58.9738 175.55C57.9855 175.55 57.4214 176.086 57.4214 177.498C57.4214 178.938 58.0425 180.011 60.0751 181.789C62.6728 184.076 63.4911 185.713 63.4911 187.972C63.4911 191.134 61.9106 192.94 58.8608 192.94C55.8119 192.94 54.2305 191.134 54.2305 187.972V186.757H57.1663V188.169C57.1663 189.58 57.7875 190.088 58.7757 190.088C59.764 190.088 60.3852 189.58 60.3852 188.169C60.3852 186.728 59.764 185.656 57.7314 183.878C55.1337 181.591 54.3155 179.954 54.3155 177.695C54.3155 174.533 55.8679 172.727 58.8888 172.727Z",
    fill: "#38879F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1967 177.837V180.406C76.1967 183.568 74.6723 185.291 71.5664 185.291H70.098V192.716H66.9932V172.953H71.5664C74.6723 172.953 76.1967 174.675 76.1967 177.837ZM70.098 175.776V182.467H71.5664C72.5547 182.467 73.0909 182.015 73.0909 180.603V177.638C73.0909 176.227 72.5547 175.775 71.5664 175.775H70.098V175.776Z",
    fill: "#38879F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0438 192.716H85.91L85.3738 189.13H81.5628L81.0266 192.716H78.1748L81.3367 172.953H85.882L89.0438 192.716ZM81.9579 186.448H84.9507L83.4833 176.454H83.4273L81.9579 186.448Z",
    fill: "#38879F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7008 192.716C98.5318 192.208 98.4187 191.897 98.4187 190.287V187.182C98.4187 185.348 97.7986 184.669 96.3862 184.669H95.3129V192.716H92.208V172.953H96.8943C100.113 172.953 101.496 174.45 101.496 177.498V179.052C101.496 181.083 100.846 182.383 99.463 183.032V183.088C101.016 183.737 101.525 185.206 101.525 187.267V190.316C101.525 191.275 101.553 191.981 101.864 192.716H98.7008ZM95.3129 175.776V181.847H96.5272C97.6845 181.847 98.3907 181.338 98.3907 179.757V177.808C98.3907 176.397 97.9106 175.776 96.8103 175.776H95.3129Z",
    fill: "#38879F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M108.386 181.281H112.649V184.104H108.386V189.893H113.751V192.716H105.28V172.953H113.751V175.776H108.386V181.281Z",
    fill: "#38879F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M120.217 178.402H120.161V192.716H117.366V172.953H121.262L124.395 184.782H124.451V172.953H127.219V192.716H124.028L120.217 178.402Z",
    fill: "#38879F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M130.269 172.953H139.868V175.776H136.621V192.716H133.516V175.776H130.27V172.953H130.269Z",
    fill: "#38879F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M158.051 185.346V187.972C158.051 191.134 156.47 192.94 153.42 192.94C150.371 192.94 148.791 191.134 148.791 187.972V177.695C148.791 174.533 150.371 172.727 153.42 172.727C156.47 172.727 158.051 174.533 158.051 177.695V179.614H155.115V177.497C155.115 176.085 154.494 175.549 153.505 175.549C152.517 175.549 151.896 176.085 151.896 177.497V188.169C151.896 189.58 152.517 190.088 153.505 190.088C154.494 190.088 155.115 189.58 155.115 188.169V185.346H158.051Z",
    fill: "#38879F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M171.717 192.716H168.583L168.047 189.13H164.235L163.698 192.716H160.847L164.01 172.953H168.555L171.717 192.716ZM164.63 186.448H167.623L166.154 176.454H166.098L164.63 186.448Z",
    fill: "#38879F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M181.374 192.716C181.205 192.208 181.092 191.897 181.092 190.287V187.182C181.092 185.348 180.47 184.669 179.059 184.669H177.987V192.716H174.881V172.953H179.568C182.786 172.953 184.17 174.45 184.17 177.498V179.052C184.17 181.083 183.521 182.383 182.138 183.032V183.088C183.691 183.737 184.198 185.206 184.198 187.267V190.316C184.198 191.275 184.227 191.981 184.538 192.716H181.374ZM177.986 175.776V181.847H179.199C180.356 181.847 181.063 181.338 181.063 179.757V177.808C181.063 176.397 180.582 175.776 179.482 175.776H177.986Z",
    fill: "#38879F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M191.058 181.281H195.321V184.104H191.058V189.893H196.423V192.716H187.952V172.953H196.423V175.776H191.058V181.281Z",
    fill: "#38879F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3548_23430",
    x: 18.7107,
    y: 2.78984,
    width: 166.612,
    height: 166.612,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3548_23430"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3548_23430",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3548_23430",
    x1: 28.138,
    y1: 69.0688,
    x2: 175.895,
    y2: 95.1224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#367B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0628,
    stopColor: "#2F6C84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2158,
    stopColor: "#204E68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3655,
    stopColor: "#163855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5091,
    stopColor: "#0F2A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6397,
    stopColor: "#0D2645"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3548_23430",
    x1: 28.0423,
    y1: 68.52,
    x2: 176.316,
    y2: 84.1041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0595,
    stopColor: "#489FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2111,
    stopColor: "#33758E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3578,
    stopColor: "#22537B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4371,
    stopColor: "#1C4674"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3548_23430",
    x1: 28.4088,
    y1: 59.9712,
    x2: 175.584,
    y2: 59.9712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0595,
    stopColor: "#54B2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    stopColor: "#306D84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3548_23430",
    x1: 101.556,
    y1: 102.314,
    x2: 101.556,
    y2: 7.08971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#479E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7126,
    stopColor: "#5ECCB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9405,
    stopColor: "#71E298"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3548_23430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105.865 45.1123) scale(57.2874 57.2874)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#51B188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3861,
    stopColor: "#52B38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6805,
    stopColor: "#58C1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8489,
    stopColor: "#5BC6B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3548_23430",
    x1: 115.188,
    y1: 60.1705,
    x2: 163.077,
    y2: 97.5849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1632,
    stopColor: "#275B71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8368,
    stopColor: "#56BBC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3548_23430",
    x1: 67.845,
    y1: 90.4295,
    x2: 88.4593,
    y2: 63.0734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    stopColor: "#5BC6B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0758,
    stopColor: "#59C2B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    stopColor: "#449695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5331,
    stopColor: "#347681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7136,
    stopColor: "#2A6275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8368,
    stopColor: "#275B71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3548_23430",
    x1: 57.6187,
    y1: 103.716,
    x2: 146.028,
    y2: 103.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0611,
    stopColor: "#4AA1BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#1A426C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8193,
    stopColor: "#387EA8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.9db9530b4a350005cdf2bdaf66138758.svg";
export { ForwardRef as ReactComponent };